import React from 'react';
import CityBuilder from '../components/cities/CityBuilder';
import PageSeo from '../components/PageSeo';

function builder() {
  return (
    <div className='mb-48'>
      <PageSeo title={`Shitty City Builder`} description={`Make your cities even shittier by purchasing an Upgrade or adding Shitty City Blocks.`} />
      <CityBuilder />
    </div>
  );
}

export default builder;
